// Import components for blocks and functionality
import FunctionsJs from "./functions";
import Gallery from "./blocks/gallery";
import Team from "./blocks/team-list";
import Accordion from "./blocks/accordion";
import Events from "./blocks/events";
import News from "./blocks/news";
import EventSlider from "./blocks/event-slider";
import Communities from "./blocks/communities";
import OurTeam from "./blocks/our-team";
import LocationsInterest from "./blocks/locations-interest";
import Tabs from "./blocks/tabs";
import FacilitiesCarousel from "./blocks/facilities-carousel";
import Timeline from "./blocks/timeline";
import FilterPosts from "./blocks/filter-posts";
import FilterApartments from "./blocks/filter-apartments";
import GalleryCarouselTab from "./blocks/gallery-carousel-tab";
import EnquireFormModal from "./blocks/enquire-form-modal";
import { flipGalleryCarousel } from './blocks/gallery-carousel';
import { flipAccorionWithImage } from "./blocks/accordion-w-image-block";

document.addEventListener("DOMContentLoaded", async () => {
	FunctionsJs.init();
	Gallery.init();
	Team.init();
	Accordion.init();
	Events.init();
	News.init();
	EventSlider.init();
	Communities.init();
	OurTeam.init();
	LocationsInterest.init();
	Tabs.init();
	FacilitiesCarousel.init();
	Timeline.init();
	FilterPosts.init();
	FilterApartments.init();
	GalleryCarouselTab.init();
	EnquireFormModal.init();

	flipGalleryCarousel();
	flipAccorionWithImage();
});
